const tabButtons = document.querySelectorAll('.guide-tabs .tab-item');
tabButtons.forEach(button => {
  button.addEventListener('click', function() {
    const index = button.getAttribute('data-tab-index');
    
    document.querySelector(`.tab-item.active`).classList.remove('active');
    button.classList.add('active');

    document.querySelector(`.tab-content.active`).classList.remove('active');

    document.querySelector(`.tab-content[data-tab-index="${index}"]`).classList.add('active');
  })
})

const categoryButtons = document.querySelectorAll('.category-tabs .category-item');
categoryButtons.forEach(button => {
  console.log(button);
  button.addEventListener('click', function() {
    const category = button.getAttribute('data-tab-category');

    document.querySelector(`.category-item.active`).classList.remove('active');
    button.classList.add('active');

    document.querySelector(`.category-content-item.active`).classList.remove('active');

    document.querySelector(`.category-content-item[data-tab-category="${category}"]`).classList.add('active');
  })
})

const helmetDropdown = document.querySelector('#helmet_model');
helmetDropdown.addEventListener('change', function(event) {
  console.log(helmetDropdown.value);

  document.querySelector(`[data-guide].active`).classList.remove('active');
  document.querySelector(`[data-guide="${helmetDropdown.value}"]`).classList.add('active');
})

const toggles = document.querySelectorAll('.guide__toggle');
toggles.forEach(toggle => {

  let active = false;

  const buttons = toggle.querySelectorAll('span');
  buttons.forEach(button => {
    button.addEventListener('click', function() {
      toggle.classList.toggle('active');
      active = !active;

      const tableId = toggle.getAttribute('data-table');

      console.log(toggle)
      const table = document.querySelector(`table[data-table="${tableId}"]`);

      const dataCells = table.querySelectorAll('td[data-inch]');

      console.log(dataCells);

      dataCells.forEach(cell => {
        const inch = cell.getAttribute('data-inch');
        const cm = cell.getAttribute('data-cm');

        cell.innerHTML = active ? inch : cm;
      })
    })
  })
})